/**
 * Transcript word/time lookup helpers.
 *
 * Relocated here from `src/pages/interviews/utils/transcript.js` so
 * cross-feature consumers (the interviews-revamp transcript player) stop
 * importing into the interviews page layer. The original module re-exports
 * `getTheWordObj` for within-feature callers.
 *
 * Both inner helpers assume `transcripts` is sorted by timestamp and run a
 * binary search to find the sentence, then the word, active at `time`.
 */
export const getTheWordObj = (transcripts, time) => {
  const currentWords = findWordsByTime(time, transcripts, 0);

  if (currentWords?.words) {
    const { words, index } = currentWords;
    return findTranscriptByTime(time, words, index, 0);
  }
  return null;
};

const findWordsByTime = (time, data, index = 0) => {
  let left = index;
  let right = data.length - 1;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const arr = data[mid];

    const startTime = arr.words[0].start_timestamp;
    const endTime = arr.words[arr.words.length - 1].end_timestamp;

    if (time >= startTime && time <= endTime) {
      return { ...arr, index: mid };
    } else if (time < startTime) {
      right = mid - 1;
    } else {
      left = mid + 1;
    }
  }

  return null;
};

const findTranscriptByTime = (time, data, wordsIndex, index = 0) => {
  let left = index;
  let right = data?.length - 1;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    const obj = data?.[mid];

    if (time >= obj.start_timestamp && time <= obj.end_timestamp) {
      return { ...obj, indexes: { sentence: '' + wordsIndex, word: '' + mid } };
    } else if (time < obj.start_timestamp) {
      right = mid - 1;
    } else {
      left = mid + 1;
    }
  }

  return null;
};
